export default {
    LayoutWithChangeLanguage: () => import('Components/layout/LayoutWithChangeLanguage.vue'),
    Loading: () => import('Components/common/Loading.vue'),
    NotFoundPage: () => import('Components/common/NotFoundPage.vue'),

    LandingPage: () => import('Components/landing/LandingPage.vue'),
    LoginPage: () => import('Components/auth/LoginPage.vue'),
    ProfilePage: () => import('Components/profile/ProfilePage.vue'),
    
    DashboardPage: () => import('Components/dashboard/DashboardPage.vue'),
    BillLandingPage: () => import('Components/bill/BillLandingPage.vue'),

    InvoiceLandingPage: () => import('Components/invoice/landing/InvoiceLandingPage.vue'),
    
    InvoicePackagePage: () => import('Components/invoice/invoicePackages/InvoicePackagePage.vue'),
    InvoicePackagePaymentPage: () => import('Components/invoice/invoicePackages/payments/InvoicePackagePaymentPage.vue'),
    InvoicePackageWalletPage: () => import('Components/invoice/invoicePackages/wallet/InvoicePackageWalletPage.vue'),
    InvoicePackageOrderCompletedPage: () => import('Components/invoice/invoicePackages/payments/completed/OrderCompletedPage.vue'),
    InvoicePackagePaymentCompletedPage: () => import('Components/invoice/invoicePackages/payments/completed/PaymentCompletedPage.vue'),
    InvoiceCreatePage: () => import('Components/invoice/forms/InvoiceCreatePage.vue'),
    InvoiceEditPage: () => import('Components/invoice/forms/InvoiceEditPage.vue'),
    InvoiceEditInformation: () => import('Components/invoice/forms/InvoiceEditInformation.vue'),
    InvoiceChoosePaymentTypePage: () => import('Components/invoice/forms/InvoiceChoosePaymentTypePage.vue'),
    InvoiceChooseShopPage: () => import('Components/invoice/forms/shop/InvoiceChooseShopPage.vue'),
    InvoiceFormShopPage: () => import('Components/invoice/forms/shop/InvoiceFormShopPage.vue'),
    InvoiceShopDetailPage: () => import('Components/invoice/forms/shop/InvoiceShopDetailPage.vue'),
    InvoiceChooseCustomerPage: () => import('Components/invoice/forms/customer/InvoiceChooseCustomerPage.vue'),
    InvoiceFormCustomerPage: () => import('Components/invoice/forms/customer/InvoiceFormCustomerPage.vue'),
    InvoiceCustomerDetailPage: () => import('Components/invoice/forms/customer/InvoiceCustomerDetailPage.vue'),
    InvoiceChooseCurrencyPage: () => import('Components/invoice/forms/InvoiceChooseCurrencyPage.vue'),
    InvoiceProductLandingPage: () => import('Components/invoice/forms/products/InvoiceProductLandingPage.vue'),
    InvoiceAddProductPage: () => import('Components/invoice/forms/products/InvoiceAddProductPage.vue'),
    ViewInvoicePage: () => import('Components/invoice/details/ViewInvoicePage.vue'),
    InvoiceDetailPage: () => import('Components/invoice/details/InvoiceDetailPage.vue'),

    ShopLandingPage: () => import('Components/shop/ShopLandingPage.vue'),
    ShopFormPage: () => import('Components/shop/ShopFormPage.vue'),
    ShopDetailPage: () => import('Components/shop/ShopDetailPage.vue'),

    CustomerCreditLandingPage: () => import('Components/customer/CustomerCreditLandingPage.vue'),
    CustomerCreditDetailPage: () => import('Components/customer/CustomerCreditDetailPage.vue'),
    CustomerLandingPage: () => import('Components/customer/CustomerLandingPage.vue'),
    CustomerFormPage: () => import('Components/customer/CustomerFormPage.vue'),
    CustomerDetailPage: () => import('Components/customer/CustomerDetailPage.vue'),

    ProductLandingPage: () => import('Components/products/ProductLandingPage.vue'),
    ProductFormPage: () => import('Components/products/ProductFormPage.vue'),

    InfoLandingPage: () => import('Components/profile/info/InfoLandingPage.vue'),
    UpdateInfoPage: () => import('Components/profile/info/UpdateInfoPage.vue'),
    ChangePasswordPage: () => import('Components/profile/info/ChangePasswordPage.vue'),
    SettingsPage: () => import('Components/profile/settings/SettingsPage.vue'),
    ChangeLanguagePage: () => import('Components/profile/settings/ChangeLanguagePage.vue'),
    AccountOrdersPage: () => import('Components/profile/AccountOrdersPage.vue'),

    NotificationPage: () => import('Components/notification/NotificationPage.vue'),
    CashFlowPage: () => import('Components/cashFlow/CashFlowPage.vue'),
}